// src/redux/slices/uploadSlice.jsx
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL for uploads
const BASE_URL = "https://onboard.rechargkit.biz/upload";

// Async thunks for each image upload
export const uploadAadharFront = createAsyncThunk(
  "upload/aadharFront",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("aadhar_front", file);
      const response = await axios.post(`${BASE_URL}/aadharFront`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadCheque = createAsyncThunk(
  "upload/aadharBack",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("upload_cheque", file);
      const response = await axios.post(`${BASE_URL}/uploadCheque`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadShopImage = createAsyncThunk(
  "upload/uploadShop",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("upload_shop", file);
      const response = await axios.post(`${BASE_URL}/uploadShop`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadProfileImage = createAsyncThunk(
  "upload/uploadProfile",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("upload_profile", file);
      const response = await axios.post(`${BASE_URL}/uploadProfile`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const uploadAadharBack = createAsyncThunk(
  "upload/uploadCheque",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("aadhar_back", file);
      const response = await axios.post(`${BASE_URL}/aadharBack`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadPanFront = createAsyncThunk(
  "upload/panFront",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("pan_front", file);
      const response = await axios.post(`${BASE_URL}/panFront`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const uploadPanBack = createAsyncThunk(
  "upload/panBack",
  async ({ member_id, file }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("member_id", member_id);
      formData.append("pan_back", file);
      const response = await axios.post(`${BASE_URL}/panBack`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  aadharFront: { status: "idle", error: null },
  aadharBack: { status: "idle", error: null },
  panFront: { status: "idle", error: null },
  panBack: { status: "idle", error: null },
};

const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Aadhar Front
      .addCase(uploadAadharFront.pending, (state) => {
        state.aadharFront.status = "loading";
        state.aadharFront.error = null;
      })
      .addCase(uploadAadharFront.fulfilled, (state) => {
        state.aadharFront.status = "succeeded";
      })
      .addCase(uploadAadharFront.rejected, (state, action) => {
        state.aadharFront.status = "failed";
        state.aadharFront.error = action.payload;
      })
      // Aadhar Back
      .addCase(uploadAadharBack.pending, (state) => {
        state.aadharBack.status = "loading";
        state.aadharBack.error = null;
      })
      .addCase(uploadAadharBack.fulfilled, (state) => {
        state.aadharBack.status = "succeeded";
      })
      .addCase(uploadAadharBack.rejected, (state, action) => {
        state.aadharBack.status = "failed";
        state.aadharBack.error = action.payload;
      })
      // PAN Front
      .addCase(uploadPanFront.pending, (state) => {
        state.panFront.status = "loading";
        state.panFront.error = null;
      })
      .addCase(uploadPanFront.fulfilled, (state) => {
        state.panFront.status = "succeeded";
      })
      .addCase(uploadPanFront.rejected, (state, action) => {
        state.panFront.status = "failed";
        state.panFront.error = action.payload;
      })
      // PAN Back
      .addCase(uploadPanBack.pending, (state) => {
        state.panBack.status = "loading";
        state.panBack.error = null;
      })
      .addCase(uploadPanBack.fulfilled, (state) => {
        state.panBack.status = "succeeded";
      })
      .addCase(uploadPanBack.rejected, (state, action) => {
        state.panBack.status = "failed";
        state.panBack.error = action.payload;
      });
  },
});

export default uploadSlice.reducer;
